var MessageListUtility = {
	cleanUpMessages: function(el) {
		var li = el.closest('li');
		if (typeof(li) == 'undefined')
			return;

		li.style.display = 'none';

		var ul = li.closest('ul');
		var hasVisible = false;
		for (var li = ul.querySelector('li'); li; li = li.next('li')) {
			if (window.getComputedStyle(li).getPropertyValue('display') != 'none') {
				hasVisible = true;
				break;
			}
		}
		if (!hasVisible) {
			var container = el.closest('.messageContainer');
			if (container)
				container.style.display = 'none';
		}
	}
};
